export const industries = [
  "Agriculture & Farming",
  "Forestry",
  "Construction & Engineering",
  "Energy Production & Utilities",
  "Water & Waste Services",
  "Casinos & Gaming",
  "Leisure Facilities",
  "Capital Markets",
  "Banking",
  "Insurance",
  "Health Care",
  "Food & Beverage Services",
  "Hotels & Lodging",
  "Aerospace & Defence",
  "Automobiles & Other Transport Vehicles",
  "Biotechnology & Pharmaceuticals",
  "Building Products & Furnishings",
  "Chemicals & Biofuels",
  "Construction Materials",
  "Electronics",
  "Food & Beverages",
  "Machinery & Equipment",
  "Medical Equipment & Services",
  "Metal Processing",
  "Oil & Gas - Midstream & Downstream",
  "Pulp, Paper & Wood products",
  "Textiles, Apparels, Footwear & Accessories",
  "Tobacco",
  "Toys, Sporting Goods & Musical Instruments",
  "Coal Operations",
  "Mining",
  "Oil & Gas - Upstream & Services",
  "Real Estate & Services",
  "Advertising & Marketing",
  "Education",
  "Professional & Commercial Services",
  "Media & Communication",
  "Software & IT Services",
  "Transportation",
  "Wholesale & Retail trade",
]